import React, { useState, useEffect } from "react";
import { Pie } from "react-chartjs-2";
import { db } from "../../FirebaseConfig";
import { UserAuth } from "../../context/AuthContext";
import {
  Chart as ChartJS,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const PieChart = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    plot_data: {
      protocol_plot: {},
    },
  });

  const { userData } = UserAuth();

  useEffect(() => {
    const getData = async () => {
      if (!userData || !userData?.id) {
        return;
      }

      setLoading(true);
      try {
        const userSubmissionsSnapshot = await db
          .collection("ChallengeSubmissions")
          .where("userid", "==", userData?.id)
          .get();

        const userSubmissions = userSubmissionsSnapshot.docs.map((doc) => ({
          category: doc.data().category,
        }));

        // Count the occurrences of each category
        const plotData = userSubmissions.reduce((acc, curr) => {
          const category = curr.category;
          acc[category] = acc[category] ? acc[category] + 1 : 1;
          return acc;
        }, {});

        setData({
          plot_data: {
            protocol_plot: plotData,
          },
        });

        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };

    getData();
  }, [userData]);

  const labels = data.plot_data && data.plot_data.protocol_plot ? Object.keys(data.plot_data.protocol_plot) : [];
  const pieData = data.plot_data && data.plot_data.protocol_plot ? Object.values(data.plot_data.protocol_plot) : [];

  const backgroundColors = [
    'rgba(255, 99, 132, 0.3)',
    'rgba(54, 162, 235, 0.3)',
    'rgba(255, 206, 86, 0.3)',
    'rgba(75, 192, 192, 0.3)',
    'rgba(153, 102, 255, 0.3)',
    'rgba(255, 159, 64, 0.3)',
    'rgba(201, 203, 207, 0.3)'
  ];

  const borderColors = [
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)',
    'rgba(201, 203, 207, 1)'
  ];

  return (
    data.plot_data && Object.keys(data.plot_data.protocol_plot).length > 0 ? (
      <div style={{ width: "95%", height: "95%", overflow: "auto" }}>
        <Pie
          data={{
            labels: labels,
            datasets: [{
              label: 'Occurrences',
              data: pieData,
              backgroundColor: backgroundColors,
              borderColor: borderColors,
              borderWidth: 1,
              weight: 1,
              hoverOffset: 15,
            }]
          }}
          options={{
            plugins: {
              legend: {
                position: 'top',
              },
              tooltip: {
                enabled: true,
              },
            },
            responsive: true,
            maintainAspectRatio: false,
            layout: {
              padding: 0,
            },
            cutout: '70%',
          }}
        />
      </div>
    ) : null
  );
};

export default PieChart;
